export default {
  name: "Trophy",
  width: 32,
  height: 32,
  viewBox: "0 0 32 32",
  path: {
    d:
      "M8.99 18.71a5.02 5.02 0 0 1-1.18-2.19c-1.51-1.66-4.38-6.55-4.8-9.68a1.9 1.9 0 0 1 1.9-2.03h2.71A2 2 0 0 1 9.6 3h12.8a2 2 0 0 1 1.98 1.8h2.71c1.1 0 1.97.93 1.9 2.03-.42 3.14-3.3 8.02-4.8 9.68a5.02 5.02 0 0 1-1.18 2.19 11.57 11.57 0 0 1-4 2.58l-.01.01v3.69l.01.02h2.98c1.11 0 2.01.9 2.01 2.01v.98c0 1.11-.9 2.01-2.01 2.01H10.01C8.9 30 8 29.1 8 27.99v-.98C8 25.9 8.9 25 10.01 25h2.98l.01-.01V21.3l-.01-.01a11.57 11.57 0 0 1-4-2.58zM7.6 12.76V6.8H5.03c.3 1.68 1.45 4.09 2.57 5.96zM24.4 6.8v5.96c1.12-1.87 2.28-4.28 2.57-5.96H24.4zm-2 8.22V5H9.6v10.02c0 .92.3 1.74.84 2.31C11.99 18.96 14.77 20 16 20c1.23 0 4.01-1.04 5.56-2.67.54-.57.84-1.39.84-2.31zM10 27v1h12v-1H10zm5-2h2v-3.11c-.36.07-.7.11-1 .11-.3 0-.64-.04-1-.11V25z",
  },
}
